<template>
  <div class="planning">
    <section class="planning-grid w-95p mt-2">
      <div v-if="errored" class="empty">
        <p>
          We are not able to retrieve this information at the moment, please try
          again later
        </p>
      </div>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Planning</p>
      </div>

    
      <table class="table-striped w-full" v-else>
        <thead class="text-gray-400">
          <tr>
            <th width="10%" v-bind:class="hasExtendedLayout ? 'pb-0' : 'pb-12'"></th>
            <th v-for="(col, index) in gridColumns" :key="index"
              class="text-center"
              :style="{width: hasExtendedLayout ? '30%' : '15%'}"
            >
              <h4 class="text-sm">{{ col}}</h4>
            </th>
          </tr>
        </thead>
        <tbody>
       
          <tr v-for="(row, year_index) in planningData" :key="year_index" v-bind:class="year_index === 3 ? 'html2pdf__page-break' : ''">
            <td
              class="text-gray-400 text-sm font-bold align-top pt-8 pl-4 cell-border"
            >
              {{ row.year }}
            </td>
            <td
              v-for="(termData, col_index) in columnData(row)"
              :key="col_index"
              class="border-b-8 border-l-4 border-white text-gray-600 text-center m-0 p-0"
            >

              <table class="w-full border-0 m-0 p-0">
                <tr
                  v-for="(unit, unit_row_index) in unitsInTerm(col_index+1, termData.units)"
                  :key="unit_row_index"
                  style="backgroundColor: rgba(255,255,255, 0.8);"
                >

                  <td v-if="'identifier' in unit"
                    class="border-b-4 border-white group cursor-pointer text-xxs hover:bg-gray-200 hover:text-gray-700 hover:text-xs h-16"
                    @click="unitSelect(unit, termData)"
                  >
                    <div v-if="editMode">
                      <i v-if="!hasExtendedLayout" class="fas fa-minus-square text-base my-1 text-red-500"></i>
                      <span v-else class="py-2 text-red-500 font-bold">edit mode</span>
                    </div>
                    <div class="w-full  p-2 text-xs text-gray-700 font-medium flex items-center justify-center " 
                    v-bind:style="{ backgroundColor: getBackgroundColor(unit) }"
                    v-bind:class="hasExtendedLayout ? 'h-8' : 'h-16'">
           
                      {{ unit.course.name }}
                    </div>
                    <div v-if="hasExtendedLayout" 
                    class="w-full h-8 grid grid-cols-2 opacity-75 text-gray-700 font-normal">
                      <div class="bg-red-300 p-2 ">{{parseRooms(unit)}}</div>
                      <div class="bg-red-200 p-2  ">{{parseTeacher(unit)}}</div>
                    </div>
                  </td>

                  <td
                    v-else
                    class="h-16 border-b-4 bg-gray-100 border-white  text-xs text-center 
                    hover:bg-green-100 hover:bg-opacity-25 hover:text-white"
                    v-bind:class="isPlanningLocked ? 'cursor-not-allowed' :'cursor-pointer'"
                    @click="selectCell(termData, col_index + 1, unit_row_index + 1)"
                  >
                  <div class="p-2 w-full h-full">
                    <i v-if="!isPlanningLocked"
                      class="fas fa-plus-circle pt-3 text-xl opacity-25 group-hover:block"
                    ></i>
                  </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { colours, termList } from "@/assets/js/utils";
import { SchoolService } from "@/services/school.service";
import { planningMixin } from "@/mixins/planningMixin.js";
import { yearGroupMixin } from "@/mixins/yearGroupMixin.js";

export default {
  mixins: [planningMixin, yearGroupMixin],
  name: "planning",
  props: {
    editMode: { type: Boolean, required: true },
    termsFiltered: { type: Array, required: true },
    teacherFiltered: { type: Object, required: false },
    roomFiltered: { type: Object, required: false },
    categoryFiltered: { type: Object, required: false }
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    editValid() {
      return this.selectedTerm != undefined && this.selectedYear > 0;
    },
    allowAdditions(){
      return this.teacherFiltered.id === 0 && this.roomFiltered.id === 0
    },
    isPlanningLocked() {
      return this.settings.planningLocked
    },
    hasExtendedLayout() {
      return this.currentUser.isSecondaryBased
    },
    planningData() {
      let vm = this
      let filterBy = this.termsFiltered
      var results = []
      if (filterBy.length === 1) {
       results = vm.plannerArrayFiltered.filter((p) => p.term_key === filterBy[0].key)
      } else {
        results = this.plannerArrayFiltered
      }

      return _.chain(results)
              .groupBy("year")
              .map((value, key) => ({ year: key, terms: value }))
              .value();
    }
  },
  data() {
    return {
      mixinName: "planning",
      hasAccess: false,
      errored: false,
      loading: true,
      colours: colours(),
      selectedTerm: undefined,
      selectedDisplayBox: 0.0,
      selectedYear: 0,
      terms: termList(),
      selectedPlan: undefined
    };
  },
  created() {
    this.loading = true;
    this.hasAccess = !this.currentUser.isOnTrial;
  },
  mounted() {},
  methods: {
    dataLoaded() {
      this.loading = false;
    },
    selectCell(term, column, row) {
      if (this.isPlanningLocked) { return }

      let colValue = this.hasExtendedLayout ? column : 1

      this.selectedYear = term.year_id;
      this.selectedTerm = this.findByKey(this.terms, term.term_key);
      this.selectedDisplayBox = parseFloat(colValue + "." + row);
      this.displayPlanningAdd()
    },
    unitSelect(object, term) {
      let vm = this;

      if (vm.editMode) {
        let payload = {
          object: object,
          year: vm.getYearGroupFromId(term.year_id),
        };

        if (this.hasExtendedLayout) {
          this.selectedPlan = object
          this.selectedYear = term.year_id;
          this.selectedTerm = this.findByKey(this.terms, term.term_key);
          this.selectedDisplayBox = object.display_box;
          this.displayPlanningAdd()
        } else {
          SchoolService.delete("planning", object.identifier, null).then(
          (response) => {
            vm.$store.commit("DELETE_PLANNING_UNIT", payload);
          });
        }
      } else {
        this.$store.commit("setUnit", object.course);
        this.$router.push({ name: "UnitView" });
        window.scrollTo(0, 0);
      }
    },
    refreshGrid(newCourse, newIdentifier) {
      this.fetchData()
    },
    getBackgroundColor(unit) {
      if (unit.course != undefined) {
        return "#" + unit.course.category.color_hex
      }
    },
    parseTeacher(unit) {
      return unit.user != undefined ? unit.user.name : "Not assigned"
    },
    parseRooms(unit) {
      if (unit.rooms == undefined) {
        return "Not assigned"
      } else {
        let title = unit.rooms[0].title
        let plus = unit.rooms.length > 1 ? " (+" + unit.rooms.length + ")" : ""
        return title + plus
      }
    },
    unitsInTerm(column, units) {
        var results = [];
        let vm = this
        let colValue = this.hasExtendedLayout ? column : 1

        for (var i = 0; i < this.gridRows; i++) {
            const value = units.find((u) =>  {

              var result = u.row === i+1 && u.column === colValue 
              if (result) {
                if (vm.teacherFiltered != undefined && vm.teacherFiltered.id > 0) {
                  result = u.user != undefined && u.user.id === vm.teacherFiltered.id
                }

                if (vm.roomFiltered != undefined && vm.roomFiltered.id != 0) {
                  result = u.rooms != undefined && u.rooms.find((r) => r.identifier === vm.roomFiltered.id)
                }

                if (vm.categoryFiltered.id > 0) {
                  result = u.course.category_id === vm.categoryFiltered.id
                }

              }
              return result
            });



            if (value !=undefined) {
              results.push(value)
            // } else if (units.length > i) {
            //   results.push(units[i])
            } else {
              results.push({});
            }
        }

        return results
      },
      displayPlanningAdd() {
        this.$router.push({
        name: "PlanningAdd",
        params: { 
          term: this.selectedTerm,
          year: this.selectedYear,
          displayBox: this.selectedDisplayBox,
          selectedPlan: this.selectedPlan },
      });
      
    }
  },
  components: {
   
  },
};
</script>

<style scoped>
.cell-border {
  border-bottom-color: #fff;
  border-bottom-width: 11px;
  border-top-width: 2px;
  border-top-color: #fff;
}

table td {
  padding: 0em;
}

</style>
